// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLE_COMPLAINT_TITLE = "Nahla\u0161uji nevhodn\u00fd \u010dl\u00e1nek";
export const ARTICLE_DELETED_BY_ADMIN = "\u010cl\u00e1nok smazan\u00fd adminem";
export const ARTICLE_DELETED_BY_AUTHOR = "\u010cl\u00e1nek smaz\u00e1n autorem";
export const ARTICLE_DELETED_BY_MODERATOR = "\u010cl\u00e1nek smazan\u00fd moder\u00e1torkou";
export const BACK_TO_BLOGS = "Zp\u011bt na p\u0159\u00edsp\u011bvky";
export const MORE_ARTICLE_SECTIONS = "Dal\u0161\u00ed rubriky \u010dl\u00e1nk\u016f";
export const PB_RECOMMENDED_ARTICLES = "Doporu\u010dujeme";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku";
export const RELATED_BLOG_ARTICLES = "Podobn\u00e9 \u010dl\u00e1nky";
export const STROLLEROPEDIA_MORE_ARTICLES = "Zobraz dal\u0161\u00ed \u010dl\u00e1nky";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
